export default __webpack_public_path__ + "static/media/confi.b67fe841.svg";